import { styled } from '@mui/system';
import { Box, Card, CardContent, Typography, Button } from '@mui/material';

export const CardWrapper = styled(Box)(({ theme }) => ({
  marginTop: 70,
  padding: theme.spacing(2),
  textAlign: 'center'
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  width: '90%',
  height: '60',
  margin: '24px auto 0 auto',
  borderRadius: '20px',
  cursor: 'pointer',
  boxShadow: '0px 0px 25px -12px rgba(0, 0, 0, 0.658)',
  '&:first-of-type': {
    marginTop: theme.spacing(2)
  }
}));

export const CardHeader = styled(CardContent)({
  display: 'flex',
  justifyContent: 'space-between',
  '&:last-child': {
    paddingBottom: 16
  }
});

export const CardHeaderText = styled(Typography)({
  fontSize: '1.1rem',
  fontWeight: 500,
  padding: '0 5px'
});

export const CardsHint = styled(Typography)({
  paddingBottom: 24,
  fontWeight: 300
});

export const CardIdentifiers = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    marginRight: theme.spacing(1.5),
    paddingBottom: '2px'
  }
}));

export const BtnCnt = styled(Box)({
  textAlign: 'center',
  position: 'absolute',
  margin: '0 auto',
  width: '100%',
  left: 0,
  top: 550
});

export const AddBtn = styled(Button)({
  justifySelf: 'end',
  fontSize: '1.1rem'
});

export const AddButtonLabel = styled('span')({
  color: 'rgba(0, 0, 0, 0.87)',
  marginLeft: 4,
  marginTop: 2,
  whiteSpace: 'nowrap'
});
